import React, { ReactNode, useMemo } from "react";
import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
} from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import { ErrorLink } from "@apollo/client/link/error";
import { contextStore } from "..";
import { errorHandler } from "../../api/client";

interface GroundProviderOpts {
  jwtToken: string;
  children: ReactNode;
}

const errorLink = new ErrorLink(errorHandler);

const createApolloClient = (jwtToken: string) => {
  // 🔗 HTTP link avec auth
  const httpLink = new HttpLink({
    uri: `${process.env.REACT_APP_BACKEND_ENDPOINT}/gql`,
    headers: { Authorization: `Bearer ${jwtToken}` },
    credentials: "include",
  });

  return new ApolloClient({
    link: ApolloLink.from([errorLink, httpLink]),
    cache: new InMemoryCache(),
  });
};

let apolloClient;
let token: string;
let GroundGraphqlContextStore: typeof contextStore;

const GroundGraphqlProvider = ({ jwtToken, children }: GroundProviderOpts) => {
  apolloClient = useMemo(() => createApolloClient(jwtToken), [jwtToken]);
  token = jwtToken;
  GroundGraphqlContextStore = contextStore;

  return (
    <ApolloProvider client={apolloClient}>
      <contextStore.Provider>{children}</contextStore.Provider>
    </ApolloProvider>
  );
};

export {
  GroundGraphqlProvider,
  GroundGraphqlContextStore,
  apolloClient as ApolloClient,
  token as Token,
};
